export default {
  DISABLE: 'DISABLE_CONVERSATION_CREATOR',
  ENABLE: 'ENABLE_CONVERSATION_CREATOR',
  HIDE: 'HIDE_CONVERSATION_CREATOR',
  SHOW: 'SHOW_CONVERSATION_CREATOR',
  HAS_STATE: 'CONVERSATION_CREATOR_HAS_STATE'
};
